module.exports = __webpack_public_path__ + "img/thumbnail_CommonOstrich_j_normal.bb7b4f0f.png";